import { createContext, useContext } from 'react';
import type { Context } from './types';

export const CategoryContext = createContext<Context>({} as Context);

export const useCategoryContext = () => {
	const categoryContext = useContext(CategoryContext);

	if (!categoryContext) {
		throw new Error('useCategoryContext has to be used within <CategoryContext.Provider>');
	}

	return categoryContext;
};
